<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import PriTama06 from './PriTama06.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ PriTama06 ],
    computed: {
      itemsSuperRainbowSkyIR () {
        const index = _.findIndex(this.itemsFiltered, { id: 'IR04-10' })
        return this.itemsFiltered.slice(index, index + 12)
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="⭐️ WR ⭐️" color="#ffca59" :items="itemsWR" />
      <ItemList title="✨ IR ✨" color="#edd50f" :items="itemsIR" />
      <ItemList title="✨ IR (再録) ✨" color="#edd50f" :items="itemsSuperRainbowSkyIR" />
      <ItemList title="サンキューキャンペーン|✨ IR ✨" color="#edd50f" :items="collection('999Campaign', 'IR')" />
    </template>

    <template #col2>
      <ItemList title="🥚 ER 🥚" color="#44cd1f" :items="itemsER" />
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR" />
      <ItemList title="キラチケいっぱい！|ハッピーキャンペーン！|クライマックス" color="#ff5d91" :items="collection('HappyCpnClimax', 'KR')" />
      <ItemList title="" color="#44cd1f" :items="collection('HappyCpnClimax', 'JR')" />
    </template>

    <template #col3>
      <ItemList title="👑 FR 👑" color="#ff5d91" :items="itemsFR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col4>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="モーリー限定 SR ★★" color="#55b272" :items="itemsMolly" />
    </template>

    <template #col5>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col6>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
    </template>


    <template #col7>
      <ItemList title="サンキューキャンペーン SR ★★" color="#00c7da" :items="collection('999Campaign', 'SR')" />
      <Status :date="date" :items="items" :showKira="true" :showNico="false" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // left: $size-unit * 100;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
